import store from '@/store/index.js'
export default {
    print_pdf: function (id) {
        let url = process.env.VUE_APP_API_ROOT + '/pdf/' + id  + '/'  + store.state.utente.token
        window.open(url, 'Print', 'height=800,width=1200')
    }
}